import React, { useContext } from 'react';
import style from './Plan.module.scss';
import classNames from 'classnames';
import { customNames, seams } from '../../constants';
import QuestionMarkIcon from '../icons/QuestionMarkIcon';
import classnames from 'classnames';
import appStyle from '../App/App.module.scss';
import PlanFeatures from './PlanFeatures';
import { IPlan } from '../../model';
import { getCostBlock } from '../Cost';
import { AppContext } from '../../context/AppContext';

interface IProps {
  plan: IPlan;
  monthAmount?: number;
  yearAmount?: number;
  state: boolean;
  setState: (state: boolean) => void;
}

const AdditionalPlan = ({plan, state, setState, monthAmount, yearAmount}: IProps) => {
  const contextData = useContext(AppContext)
  const { yearly } = contextData || {};

  let additionalCostBlock;

  let additionalPlan = plan.additional;

  additionalCostBlock = getCostBlock({
    yearly,
    monthAmount: additionalPlan?.prices?.monthly?.unit_amount ?? 0,
    // prevMonthAmount: monthAmount,
    yearAmount: additionalPlan?.prices?.yearly?.unit_amount ?? 0,
    prevYearAmount: yearAmount
  })
  if (state) additionalCostBlock = ''

  return (
    <div className={style.additionalPlan_wrapper}>
      {additionalPlan ? <div
        className={classNames(style.additionalPlan, {[style.add_seams]: seams.includes(additionalPlan?.plan_id)})}>
        <div className={classNames(style.additionalPlan__title)}>
          {`Add ${customNames[additionalPlan.plan_id] ?? customNames[plan.plan_id + '_' + additionalPlan.plan_id] ?? additionalPlan.display.name}`.split('').map(i => i === ' ' ?
            <i>&nbsp;</i> : <span>{i}</span>)}
        </div>
        <QuestionMarkIcon/>
        <div className={classnames(appStyle.switch, style.switch)}>
          <label className={classnames(appStyle.switch_wrapper, style.switch_wrapper)}>
            <input type="checkbox" name="additional" checked={state}
                   onChange={() => setState(!state)}/>
            <span className={classnames(appStyle.switch_toggle, style.switch_toggle)}></span>
          </label>
        </div>

        <div className={style.additionalPlan_hover_card}>
          <div className={style.additionalPlan_hover_card_inner}>
            <div className={style.additionalPlan_hover_card_header}>
              <h3 className={style.additionalPlan_hover_card_title}>{additionalPlan.display.name}</h3>
              <div className={style.additionalPlan_hover_card_billed}>
                {additionalCostBlock}
              </div>
            </div>
            {additionalPlan.features?.length > 0 || window?.shortDescriptions?.[additionalPlan.plan_id] ? <>
              <hr className={style.divider}/>
              <PlanFeatures plan={additionalPlan}/>
            </> : ''}
          </div>
        </div>
      </div> : ''}
    </div>
  );
};

export default AdditionalPlan;
